import * as angular from "angular";
import {CommonsService} from "../commons/services/commons-service.service";

angular
  .module('bringoz.admin.recommendation')
  .config(RecommendationConfig);


/* @ngInject */
function RecommendationConfig($stateProvider) {
  $stateProvider

    .state('recommendation', {
      parent: 'bringoz.site',
      abstract: true,
      url: '/recommendation',
      template: '<ui-view></ui-view>',
      controller: function (site) {
      }
    })

}

